import { useState, useEffect } from "react";
import * as theme from "../../../theme";
import TransactionHistoryItem from "../items/TransactionHistoryItem";
import { Pagination } from '@mui/material';

export default function TransactionHistoryList(props) {
  const [sortedTransactions, setSortedTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const sortTransactionsByDate = (transactions) => {
    return [...transactions].sort((a, b) => {
      const dateA = a.dateCreated.toDate ? a.dateCreated.toDate() : new Date(a.dateCreated);
      const dateB = b.dateCreated.toDate ? b.dateCreated.toDate() : new Date(b.dateCreated);
      return dateB - dateA; // Descending order (newest first)
    });
  };

  useEffect(() => {
    if (props && props.transactions != null) {
      setSortedTransactions(sortTransactionsByDate(props.transactions));
      setCurrentPage(1); // Reset to first page on new data
    }
  }, [props.transactions]);

  const totalPages = Math.ceil(sortedTransactions.length / pageSize);
  const indexOfLast = currentPage * pageSize;
  const indexOfFirst = indexOfLast - pageSize;
  const currentTransactions = sortedTransactions.slice(indexOfFirst, indexOfLast);

  return (
    <div style={theme.Container.listColumn}>
      {sortedTransactions.length > 0 ? (
        <>
          {currentTransactions.map((transaction) => (
            <TransactionHistoryItem
              key={transaction.id}
              transaction={transaction}
              clients={props.clients}
              practitioner={props.practitioner}
            />
          ))}
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
              <Pagination 
                count={totalPages} 
                page={currentPage} 
                onChange={(event, value) => setCurrentPage(value)} 
                color="secondary"
              />
            </div>
          )}
        </>
      ) : (
        <div style={theme.SubHeadingText}>No transactions found.</div>
      )}
    </div>
  );
}